<template>
  <div class="mains">
    <div class="campus">
      教务管理
      <span>></span>
      <router-link to="campus">分校区管理</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">校区管理</div>
          <router-link to="campusnew">
            <el-button type="primary" class="buttons">
              <span>+</span> 新建校区
            </el-button>
          </router-link>
          <div class="sousuo">
            <span>创建时间：</span>
            <el-date-picker class="pickers" v-model="timetotime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            <span>校区名称：</span>
            <el-input v-model="orgname" @keyup.13.native="chaxun" placeholder="请输入校区名称或校区代码"></el-input>
            <el-button type="primary" class="buttons" @click="chaxun()">查 询</el-button>
          </div>
          <div class="zsbg">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="name" label="校区名称" max-width="360"></el-table-column>
              <el-table-column prop="orgcode" label="校区代码" min-width="50"></el-table-column>
              <el-table-column prop="showCreateTime" label="创建时间"></el-table-column>
              <el-table-column label="校区基本账号">
                <template slot-scope="scopes">
                  <!-- Table -->
                  <el-button type="text" @click="dialogTableVisibles(scopes.row.id)" class="chakan">查看</el-button>
                  <el-dialog title="校区基本账号" :visible.sync="dialogTableVisible" width="600px">
                    <el-table :data="gridData" border class="qingkuang">
                      <el-table-column property="username" label="校区账号"></el-table-column>
                      <el-table-column property="creatorname" label="创建人"></el-table-column>
                      <el-table-column property="address" label="账号密码"></el-table-column>
                    </el-table>
                  </el-dialog>
                </template>
              </el-table-column>
              <el-table-column label="账号状态">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.booleanStatus" active-color="#07C160" inactive-color="#E5E5E5" @change="zhuangtai(scope.row.booleanStatus, scope.row.id)"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="stData">
                  <!--<el-button type="text">APP下载页</el-button>-->
                  <el-button type="text" @click="updateOrg(stData.row.id)">编辑</el-button>
                  <el-button type="text" @click="del(stData.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'campus',
  data() {
    return {
      orgname: '',
      gridData: [],
      tableData: [],
      searchData: [],
      timetotime: '',
      // 检索表单数据对象
      page: 1,
      pageSize: 5,
      currentPage: 1,
      disablePage: false,
      total: 0,
      dialogTableVisible: false
    };
  },
  mounted() {
    this.chaxun();
  },
  watch: {
    timetotime() {
      this.chaxun();
    }
  },
  methods: {
    updateOrg(id) {
      // console.log(id)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/org/getOrgByid/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          var obj = result.data.data;
          // console.log(obj)
          this.$store.commit('updateUser', obj);
          this.$router.push({
            path: '/campusedit'
          });
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('修改校区失败：' + err);
        });
      // this.$router.push({ path: '/campusedit' })
    },
    chaxun() {
      console.log(this.page);

      let timetotime = this.timetotime;
      let fromtime = '';
      let totime = '';
      let orgname = this.orgname;
      if (timetotime !== '' && timetotime !== null) {
        let size = timetotime.length;
        console.log(size);
        if (size === 1) {
          fromtime = timetotime[0];
        } else if (size === 2) {
          fromtime = timetotime[0];
          totime = timetotime[1];
        }
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/org/selectByParentId',
        method: 'POST',
        data: {
          orgid: orgid,
          fromtime: fromtime,
          totime: totime,
          name: orgname,
          page: this.page,
          pageSize: this.pageSize
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          var data = result.data.data;
          this.tableData = data;
          // console.log(data)
          this.disablePage = true;
          if (data === undefined || data === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得校区失败：' + err);
        });
      // console.log(this.searchData)
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      // this.$options.methods.chaxun()
      this.chaxun();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.chaxun();
    },
    dialogTableVisibles(e) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/org/getOrgAccount',
        method: 'POST',
        data: {
          orgid: e
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          var data = result.data.data;
          this.gridData = data;
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得账号失败：' + err);
        });
      this.dialogTableVisible = true;
      // console.log(e)
    },
    zhuangtai(index, id) {
      // 确认事情
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/org/updateEduOrgStatus',
        method: 'POST',
        data: {
          id: id,
          booleanStatus: index
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // 删除成功
          // console.log(result)
          // this.chaxun()
          // this.getArticleList()
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('删除校区失败：' + err);
        });
    },
    // 删除
    del(id) {
      // 确认事情
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/org/deleteOrgByid/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // 删除成功
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.chaxun();
          })
          .catch(err => {
            return this.$message.error('删除校区失败：' + err);
          });
      });
    }
  }
};
</script>

<style lang="less">

</style>
